import { render } from "./starter-index.vue?vue&type=template&id=398bf362"
import script from "./starter-index.vue?vue&type=script&lang=js"
export * from "./starter-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__